export const DONATE = "payment/donate";